export default "__VITE_ASSET__CbP2vu5$__"